/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#confirm-button[_ngcontent-%COMP%]:hover{background-color:#f1f1f1}"];
export { styles as styles };
